module.exports = "https://la-static.vkplay.ru/promo/newstart/img/destroyer.eeb8eb82.png";